(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/racing-arena/assets/javascripts/racecards/racecard-picker.js') >= 0) return;  svs.modules.push('/modules/racing-arena/assets/javascripts/racecards/racecard-picker.js');

'use strict';

const useEffect = React.useEffect;
const useState = React.useState;
const dateFns = window.dateFns;
const fetchRacecard = svs.racing.raceService.fetchRacecard;
const fetchRacecardHot = svs.racing.raceService.fetchRacecardHot;
const racePickerModes = svs.racing.common.constants.racePickerModes;
const DateField = svs.components.DateField;
const {
  baseUrl
} = svs.core.data;
const {
  ReactIcon
} = svs.ui;
const ReactItemsMenu = svs.ui.ReactItemsMenu.ItemsMenu;
const ReactLinkItem = svs.ui.ReactItemsMenu.LinkItem;
const Button = svs.ui.ReactButton;
const formatDate = date => dateFns.format(date, 'yyyy-MM-dd');
const parseDay = day => dateFns.parseISO(day);
const isMobile = svs.core.detect.formfactor.mobile();
const RacecardPicker = props => {
  const {
    setRacecard,
    racePickerMode,
    setDate,
    racecard
  } = props;
  const date = setDate === undefined ? formatDate(new Date()) : formatDate(setDate);
  const [day, setDay] = useState(date);
  const [calenderOpen, setCalenderOpen] = useState(false);
  const previousDay = formatDate(dateFns.subDays(parseDay(day), 1));
  const nextDay = formatDate(dateFns.addDays(parseDay(day), 1));
  useEffect(() => {
    if (racePickerMode === racePickerModes.HOT) {
      setRacecard({
        currentRacecard: svs.racing_arena.data.racecardHot,
        currentRacePickerMode: racePickerModes.HOT
      });
    } else if (racePickerMode === racePickerModes.TIMELINE) {
      fetchRacecard(day, (err, racecard) => {
        setRacecard({
          currentRacecard: racecard,
          currentRacePickerMode: racePickerModes.TIMELINE
        });
      });
    } else {
      fetchRacecard(day, (err, racecard) => {
        setRacecard({
          currentRacecard: racecard,
          currentRacePickerMode: racePickerModes.ALL
        });
      });
    }
  }, [day]);
  const updateUrl = extraInfo => {
    window.history.pushState(null, null, "".concat(baseUrl).concat(extraInfo));
  };
  const updateDate = (e, updatedDay) => {
    if (e) {
      e.preventDefault();
    }
    setDay(updatedDay);
    updateUrl("/".concat(updatedDay));
  };
  return React.createElement(React.Fragment, null, svs.core.detect.formfactor.mobile() ? React.createElement("div", {
    className: "racecard-selector items-menu-racing"
  }, React.createElement(ReactItemsMenu, {
    branding: "racing"
  }, React.createElement(ReactLinkItem, {
    label: "Heta",
    onClick: () => {
      updateUrl("?mode=".concat(racePickerModes.HOT));
      fetchRacecardHot((err, racecard) => {
        setRacecard({
          currentRacecard: racecard,
          currentRacePickerMode: racePickerModes.HOT
        });
      });
    },
    selected: racePickerMode === racePickerModes.HOT,
    width: 88
  }, React.createElement(ReactIcon, {
    color: "fc-racing-900",
    icon: "hot",
    size: "400"
  })), React.createElement(ReactLinkItem, {
    label: "Tidslinje",
    onClick: () => {
      updateUrl("?mode=".concat(racePickerModes.TIMELINE));
      fetchRacecard(day, (err, racecard) => {
        setRacecard({
          currentRacecard: racecard,
          currentRacePickerMode: racePickerModes.TIMELINE
        });
      });
    },
    selected: racePickerMode === racePickerModes.TIMELINE,
    width: 88
  }, React.createElement(ReactIcon, {
    color: "fc-racing-900",
    icon: "clock-simple",
    size: "400"
  })), React.createElement(ReactLinkItem, {
    label: "Alla",
    onClick: () => {
      updateUrl("?mode=".concat(racePickerModes.ALL));
      fetchRacecard(day, (err, racecard) => {
        setRacecard({
          currentRacecard: racecard,
          currentRacePickerMode: racePickerModes.ALL
        });
      });
    },
    selected: racePickerMode === racePickerModes.ALL,
    width: 88
  }, React.createElement(ReactIcon, {
    color: "fc-racing-900",
    icon: "all-meetings",
    size: "400"
  })))) : React.createElement("div", {
    className: "racecard-selector items-menu-racing align-center"
  }, React.createElement(ReactItemsMenu, {
    branding: "racing"
  }, React.createElement(ReactLinkItem, {
    label: "Tidslinje",
    onClick: () => {
      updateUrl("?mode=".concat(racePickerModes.TIMELINE));
      fetchRacecard(day, (err, racecard) => {
        setRacecard({
          currentRacecard: racecard,
          currentRacePickerMode: racePickerModes.TIMELINE
        });
      });
    },
    selected: racePickerMode === racePickerModes.TIMELINE,
    width: 88
  }, React.createElement(ReactIcon, {
    color: "fc-racing-900",
    icon: "clock-simple",
    size: "400"
  })), React.createElement(ReactLinkItem, {
    label: "Alla",
    onClick: () => {
      updateUrl("?mode=".concat(racePickerModes.ALL));
      fetchRacecard(day, (err, racecard) => {
        setRacecard({
          currentRacecard: racecard,
          currentRacePickerMode: racePickerModes.ALL
        });
      });
    },
    selected: racePickerMode === racePickerModes.ALL,
    width: 88
  }, React.createElement(ReactIcon, {
    color: "fc-racing-900",
    icon: "all-meetings",
    size: "400"
  })))), (racePickerMode === racePickerModes.ALL || racePickerMode === racePickerModes.TIMELINE) && React.createElement("div", {
    className: "picker-calendar-holder".concat(racePickerMode === racePickerModes.TIMELINE && !isMobile && racecard && racecard.length > 0 ? ' time-line-mode' : '')
  }, React.createElement("div", {
    className: "picker-calendar"
  }, React.createElement("div", {
    className: "button-prev inline-block ".concat(calenderOpen ? 'hide' : '')
  }, React.createElement(Button, {
    className: "icon-button btn-icon-holder",
    Component: false,
    href: "".concat(baseUrl, "/").concat(previousDay),
    onClick: e => {
      updateDate(e, previousDay);
    },
    size: 100
  }, React.createElement(ReactIcon, {
    color: "fc-white",
    icon: "menu-left",
    size: "100"
  }))), React.createElement("div", {
    className: "datefield inline-block"
  }, React.createElement(DateField, {
    format: date => {
      const string = dateFns.format(new Date(date), "EEEE, d/M, '(v'w')'", {
        locale: dateFns.locales.sv
      });
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    inputProps: {
      value: parseDay(day)
    },
    onChange: date => {
      updateDate(null, formatDate(date.obj));
    },
    pickadateOptions: {
      isOpen: status => {
        setCalenderOpen(status.open);
      },
      isTodayOrTomorrow: true,
      klass: {
        navPrev: 'calendar-left-arrow icon-default icon-menu-left js-previous pointer',
        month: 'racing-header-month inline-block',
        year: 'racing-header-year inline-block',
        weekdays: 'racing-table-weekdays padding-xs-bottom',
        buttonClose: 'btn btn-100 btn-transparent-inverted',
        navNext: 'calendar-right-arrow icon-default icon-menu-right js-next pointer',
        opened: 'picker--opened',
        picker: 'picker date-picker-default'
      },
      openCloseInput: true
    }
  })), React.createElement("div", {
    className: "button-next inline-block ".concat(calenderOpen ? 'hide' : '')
  }, React.createElement(Button, {
    className: "icon-button btn-icon-holder",
    Component: false,
    href: "".concat(baseUrl, "/").concat(nextDay),
    onClick: e => {
      updateDate(e, nextDay);
    },
    size: 100
  }, React.createElement(ReactIcon, {
    color: "fc-white",
    icon: "menu-right",
    size: "100"
  }))))));
};
svs.racing_arena.RacecardPicker = RacecardPicker;

 })(window);